import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import BannerStepLayout from ".././BannerStepLayout/BannerStepLayout";

const BannerStepList = () => {
	const { control } = useFormContext<BannerFormState>();

	const { steps } = useWatch({ control });

	const sortedSteps = steps
		? [...steps].sort((a, b) => {
				const aIsName = a.title?.toLowerCase().includes("name") ? 0 : 1;
				const bIsName = b.title?.toLowerCase().includes("name") ? 0 : 1;
				return aIsName - bIsName;
			})
		: [];

	return (
		<div className="flex flex-col gap-4">
			{sortedSteps.map((step) => (
				<BannerStepLayout key={step.step} data={step as BannerStep} />
			))}
		</div>
	);
};

export default BannerStepList;
